module.exports = __webpack_public_path__ + "abee8b4af0f1468bf4ecf98dab552faf.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/total/totalwidgetexample.png
// module id = 818
// module chunks = 7